// RITA-1552 — Die zwei Vorgänge der Vertragserstellung beim Berater (Skizze Rücklauf vom 21.10.2026, freigegeben von
// Julia): „Vertrag erstellen“ (Anschreiben Versand und Vertrag) und „Rücksendung drucken“ (nur das Anschreiben
// Rücksendung). Je Vorgang gibt es eigene Arten, einen eigenen Entwurf und einen eigenen Druck; die Zuordnung der
// Arten führt der Server als eigene Konstante (CONTRACT_CREATION_PROCESS_KINDS), hier dieselbe Liste.
//
// Bewusst nur mit Typimporten: Texte, Druckeingabe und Vorgangskonfiguration importieren diese Datei, nicht umgekehrt
// (ESLint lässt keine Import-Zyklen zu; Kritik zum Bauplan, P3).
import type { ContractCreationKind, ContractCreationProcess } from 'global-intern-types';

export type Vorgang = ContractCreationProcess;

/** Arten je Vorgang in der festen Reihenfolge der PDF: Anschreiben Versand vor Vertrag. */
export const VORGANG_ARTEN: Readonly<Record<Vorgang, readonly ContractCreationKind[]>> = {
  contract: ['dispatch_letter', 'contract'],
  return: ['return_letter'],
};

/** Alle Arten in der Reihenfolge des Servers (die Karte fragt alle drei ab: „Passend für …“ nennt auch die Rücksendung). */
export const ALLE_ARTEN: readonly ContractCreationKind[] = ['dispatch_letter', 'contract', 'return_letter'];

/** Name des Such-Parameters der Bearbeiten-Seite, der den Vorgang trägt. */
export const VORGANG_PARAMETER = 'vorgang';
/**
 * RITA-1601 (Fund 128): Such-Parameter der Bearbeiten-Seite mit der Kennung des Drucks mit Vertrag, dessen Ersetzen in der
 * Karte mit „Trotzdem neuen erstellen“ bestätigt wurde (`?neu=1&dokument=vertrag&ersetztVertrag=7`). Die Seite fragt dann
 * vor einem Druck mit Vertrag nicht noch einmal „Schon ein Vertrag gedruckt“ – solange genau dieser Vertrag der neueste
 * ist. Ein veralteter Wert (inzwischen anderer Vertrag) ist unschädlich: Dann wird wieder gefragt.
 */
export const ERSETZT_VERTRAG_PARAMETER = 'ersetztVertrag';
/** Wert des Such-Parameters für die Rücksendung; ohne Parameter gilt der Vertrag (Bestand 3b/3c). */
export const SUCHWERT_RUECKSENDUNG = 'ruecksendung';

/** Vorgang aus dem Such-Parameter `vorgang` der Bearbeiten-Seite; alles außer „ruecksendung“ ist der Vertrag. */
export const vorgangAusSuche = (wert: string | null | undefined): Vorgang =>
  wert === SUCHWERT_RUECKSENDUNG ? 'return' : 'contract';

/**
 * Such-Parameter des Vorgangs für die Adresse der Bearbeiten-Seite, OHNE führendes „?“ oder „&“, damit er sich mit
 * weiteren Parametern verbinden lässt (z. B. `?neu=1&vorgang=ruecksendung`). Der Vertrag hat keinen Parameter (leer).
 */
export const vorgangSuche = (vorgang: Vorgang): string =>
  vorgang === 'return' ? `${VORGANG_PARAMETER}=${SUCHWERT_RUECKSENDUNG}` : '';
